import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './productgroup.scss';
import sortbydot from '../../../../assets/image/sort_by_group.svg';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import BulkImport from '../BulkImport';
import Button from '../../../../component/ui/Button';
import { change_status, product_list_data } from '../../../../store/action/product';
import { group_update, product_group_list } from '../../../../store/action/group';
import InputSelect from '../../../../component/inputSelect/InputSelect';
import AddToGroupModal from '../AddToGroupModal';
import Modal from '../../../../component/modal/Modal';
import { status_dropdown } from '../../../../utils/dropsdown';
import { formatErrors, hasPermission } from '../../../../utils/controller';
import { ExportTable } from '../../../../store/action/export/Export';
import InputField from '../../../../component/form/FormInput';
import Pagination from '../../../../component/pagination';
import { ProductTableColumn } from '../TableColoum';
import Table from '../../../../component/table/Table';

const GroupDetails = () => {
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const productId = param?.id;
	const GroupID = param?.id;
	const navigateRouter = (path) => {
		navigate(path);
	};
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [totalPages, setTotalPages] = useState(0);
	const [bulkAction, setBulkAction] = useState([]);
	const [open, setIsOpen] = useState(false);
	const [buklImport, setIsbuklImport] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [tableData, setTableData] = useState([]);
	const [groupOption, setGroupOptions] = useState([]);
	const [stateCondition, setStateCondition] = useState('');
	const [groupName, setgroupName] = useState('');
	const [groupStatus, setgroupStatus] = useState('1');
	const [error, setError] = useState({});
	const [headerDropDown, setHeaderDropDown] = useState('All Product');
	const [filterparam, setFilterparam] = useState('');
	const [projectTitle, setProjectTitle] = useState('Group Detail');
	const [sortParam, setSortParam] = useState('');
	const [productList, setProductList] = useState([]);
	const [loading, setLoader] = useState(false);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const handlePageChange = (page) => setCurrentPage(page);

	const getAllProduct = async (param = `page=${currentPage}&pageSize=${pageSize}`, value) => {
		try {
			setLoader(true);
			if (value) setStateCondition(value);
			const res = await product_list_data(param);
			setProductList(res?.success ? res.data : {});
		} catch {
			setProductList({});
		} finally {
			setLoader(false);
		}
	};

	const groupList = async () => {
		const param = `filterBy=product_group_id&filterValue=${GroupID}`;
		const res = await product_group_list(param);
		const group = res?.data?.productGroups?.[0] || {};
		setgroupName(group.name || '');
		setgroupStatus(String(group.status ?? ''));
	};

	const filterProduct = (param, value, label) => {
		setFilterparam(param);
		setStateCondition(value);
		setHeaderDropDown(label);
		setSortParam('');
		setCurrentPage(1);
	};

	const sortProduct = (param) => {
		setSortParam(param);
		setCurrentPage(1);
	};

	const updateProductStatus = (status) => {
		const body = { product_ids: bulkAction, status };
		change_status(body).then((res) => {
			if (res.success) {
				toast.success(
					`Selected products have been ${status === 1 ? 'activated' : 'deactivated'} successfully.`,
				);
				groupList();
			} else {
				toast.error(res?.message);
			}
		});
	};

	const markAsActive = () => updateProductStatus(1);
	const markAsInactive = () => updateProductStatus(0);
	const handleRowDataChange = (newData) => {};

	const handlegroupUpdate = () => {
		const body = { name: groupName, status: Number(groupStatus) };
		dispatch(group_update(GroupID, body)).then((res) => {
			if (res?.success) {
				toast.success(res.message);
			} else {
				toast.error(res?.message);
				setError(formatErrors(res?.data?.message));
			}
		});
	};

	const exportData = (param) => ExportTable(param);

	useEffect(() => {
		groupList();
	}, []);

	useEffect(() => {
		if (productList?.productWithStockCount) {
			const data = productList.productWithStockCount.map((ele) => ({
				id: ele.product_id,
				'PRODUCT NAME': ele.product_name,
				'PRODUCT CODE': ele.product_code,
				'STOCK IN HAND': ele.stock_in_hand,
				'REORDER LEVEL': 'NA',
				Status: 'Enable',
			}));
			setTableData(data);
			setTotalPages(Math.ceil((productList.totalCount || 0) / pageSize));
		}
	}, [productList]);

	useEffect(() => {
		if (productId) {
			getAllProduct(
				`filterBy=product_group_id&filterValue=${productId}&page=${currentPage}&pageSize=${pageSize}`,
			);
		}
	}, [productId, sortParam, filterparam, currentPage, pageSize]);

	useEffect(() => {
		document.title = `${projectTitle} | Pharmnex`;
	}, [projectTitle]);

	return (
		<div>
			<div className="group-details-sticky">
				{bulkAction && bulkAction.length > 0 ? (
					<div className="product-pg-header">
						<div className="dropdown text-end">
							<p className="d-block link-dark text-decoration-none">Bulk Actions</p>
						</div>
						<div className="add-product-button">
							{stateCondition !== 'active' && (
								<Button
									type="button"
									button="Mark as Active"
									disabled={!hasPermission('inventory.products.edit', user?.role?.role_permissions)}
									className="mt-0 px-4 btn-gray"
									onClick={markAsActive}
								/>
							)}
							{stateCondition !== 'inactive' && (
								<Button
									type="button"
									button="Mark as Inactive"
									disabled={!hasPermission('inventory.products.edit', user?.role?.role_permissions)}
									className="mt-0 px-4 btn-gray"
									onClick={markAsInactive}
								/>
							)}
						</div>
					</div>
				) : (
					<div className="product-pg-header">
						{productId ? (
							<div className="dropdown text-end">
								<a className="d-block link-dark text-decoration-none">
									<p>Group Details</p>
								</a>
							</div>
						) : (
							<div className="dropdown text-end">
								<a
									className="d-block link-dark text-decoration-none dropdown-toggle"
									id="dropdownUser1"
									data-bs-toggle="dropdown"
									aria-expanded="false"
								>
									<p>{headerDropDown}</p>
								</a>
								<ul
									className="dropdown-menu font-14"
									aria-labelledby="dropdownUser1"
									style={{ minWidth: '240px' }}
								>
									<li>
										<a
											className="dropdown-item"
											onClick={() =>
												filterProduct('orderBy=product_code&sortBy=asc', '', 'All Products')
											}
										>
											All Products
										</a>
									</li>
									<li>
										<a
											className="dropdown-item"
											onClick={() =>
												filterProduct('filterBy=status&filterValue=1', 'active', 'Acitive Products')
											}
										>
											Acitive Products
										</a>
									</li>
									<li>
										<a
											className="dropdown-item"
											onClick={() =>
												filterProduct('filterBy=stock_in_hand', '', 'Low Stock Products')
											}
										>
											Low Stock Products
										</a>
									</li>
									<li>
										<a
											className="dropdown-item"
											onClick={() => filterProduct('', '', 'Sales')}
										>
											Sales
										</a>
									</li>
									<li>
										<a
											className="dropdown-item"
											onClick={() => filterProduct('', '', 'Purchase')}
										>
											Purchase
										</a>
									</li>
									<li>
										<a
											className="dropdown-item"
											onClick={() =>
												filterProduct(
													'filterBy=status&filterValue=0',
													'inactive',
													'Inactive Products',
												)
											}
										>
											Inactive Products
										</a>
									</li>
								</ul>
							</div>
						)}
						<div className="d-flex align-items-center">
							{productId ? (
								<div className="add-product-button">
									<Button
										type="button"
										className="btn-primary mt-0 px-4"
										disabled={
											GroupID
												? !hasPermission('inventory.groups.edit', user?.role?.role_permissions)
												: !hasPermission('inventory.groups.create', user?.role?.role_permissions)
										}
										button="Save"
										onClick={handlegroupUpdate}
									/>
									<Button
										type="button"
										className="mt-0 btn-danger add-pro"
										button=""
										close
										onClick={() => navigateRouter(`/user/${suburl}/group`)}
									/>
								</div>
							) : (
								<></>
							)}
							{!productId && (
								<div className="dropdown text-end ms-3">
									<a
										className="d-block link-dark text-decoration-none"
										id="dropdownUser1"
										data-bs-toggle="dropdown"
										aria-expanded="false"
									>
										<img src={sortbydot} />
									</a>
									<ul
										className="dropdown-menu font-14"
										aria-labelledby="dropdownUser1"
										style={{ minWidth: '240px' }}
									>
										<li>
											<a className="dropdown-item sortBy">Sort by</a>
										</li>
										<li>
											<a
												className="dropdown-item"
												onClick={() => sortProduct('orderBy=created_at&sortBy=asc ')}
											>
												Created Time
											</a>
										</li>
										<li>
											<a
												className="dropdown-item"
												onClick={() => sortProduct('orderBy=product_name&sortBy=asc')}
											>
												Name
											</a>
										</li>
										<li>
											<a
												className="dropdown-item"
												onClick={() => sortProduct('orderBy=product_code&sortBy=asc')}
											>
												Product Code
											</a>
										</li>
										<li>
											<a
												className="dropdown-item"
												onClick={() => sortProduct('orderBy=stock_in_hand&sortBy=asc')}
											>
												Stock on Hand
											</a>
										</li>
										<li>
											<a
												className="dropdown-item"
												onClick={() => sortProduct('orderBy=updated_at&sortBy=asc')}
											>
												Last Modified Time
											</a>
										</li>
										<hr />
										{hasPermission('inventory.products.import', user?.role?.role_permissions) && (
											<li>
												<a
													className="dropdown-item"
													onClick={() => setIsbuklImport(true)}
												>
													Import Product
												</a>
											</li>
										)}
										{hasPermission('inventory.products.export', user?.role?.role_permissions) && (
											<li>
												<a
													className="dropdown-item"
													onClick={() => exportData(`product`)}
												>
													Export Product
												</a>
											</li>
										)}
										<hr />
										<li>
											<a className="dropdown-item">Prefrence</a>
										</li>
										<li>
											<a
												className="dropdown-item"
												onClick={() => getAllProduct('')}
											>
												Refresh
											</a>
										</li>
									</ul>
								</div>
							)}
							{/* {productId && <Button type="button" className="mt-0 btn-danger add-pro" button="" close onClick={() => navigateRouter(-1)} />} */}
						</div>
					</div>
				)}

				{productId && bulkAction?.length === 0 && (
					<div className="add-group-detail px-2 mx-2 py-3 my-2">
						<div className="row">
							<div className="col-5">
								<InputField
									label="Group Name"
									placeholder="Enter Group Name"
									type="text"
									onChange={(val) => setgroupName(val)}
									value={groupName}
									error={error?.name}
								/>
							</div>
							<div class="col-3">
								<InputSelect
									label="Status"
									placeholder="Status"
									onChange={(value) => setgroupStatus(value)}
									value={groupStatus}
									options={status_dropdown || []}
									error={error?.status}
								/>
							</div>
						</div>
					</div>
				)}
			</div>

			{loading ? (
				<div
					className="d-flex justify-content-center align-items-center"
					style={{ height: '100%', marginTop: '20%' }}
				>
					<span
						className="Page_loader"
						role="status"
						aria-hidden="true"
					></span>
				</div>
			) : (
				<Table
					row={tableData}
					className="productTable"
					coloum={ProductTableColumn}
					onRowDataChange={handleRowDataChange}
					action={setBulkAction}
				/>
			)}
			<Pagination
				currentPage={currentPage}
				totalPages={totalPages}
				onChangePage={handlePageChange}
				pageSize={pageSize}
				setParam={(value) => {
					setPageSize(value);
					setCurrentPage(1);
				}}
			/>
			{open && (
				<div>
					<Modal
						className="add-productgroup-modal"
						isOpen={open}
						onClose={() => setIsOpen(false)}
						title="Add to Group"
					>
						<AddToGroupModal
							isOpen={open}
							onCLose={() => setIsOpen(false)}
							reloadTable={getAllProduct}
							groupOption={groupOption}
							action={bulkAction}
						/>
					</Modal>
				</div>
			)}

			{buklImport && (
				<div>
					<Modal
						className="add-productgroup-modal"
						isOpen={buklImport}
						onClose={() => setIsbuklImport(false)}
						title=" Product bulk Import "
					>
						<BulkImport
							isOpen={buklImport}
							onClose={() => setIsbuklImport(false)}
							reloadTable={getAllProduct}
							type={'product'}
						/>
					</Modal>
				</div>
			)}
		</div>
	);
};

export default GroupDetails;
